module.exports = __webpack_public_path__ + "img/Icon=Dart.aeda691e.svg";